import { render, staticRenderFns } from "./DataBackupView.vue?vue&type=template&id=de54baf8&"
import script from "./DataBackupView.vue?vue&type=script&lang=js&"
export * from "./DataBackupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports